import Api from 'services/api'

export function setLoanNumber(defaultLoanNumber: number = 0) {
  if (defaultLoanNumber) {
    Api.setLoanNumber(`${defaultLoanNumber}`)
    return defaultLoanNumber
  }

  const { href } = window.location
  if (href.endsWith('/new') || href.includes('/new/') || href.includes('/pool/')) return 0
  let params: any = href.split('?')[0]
  params = params.split('/')
  const loanNumber = params[params.length - 1]
  if (isNaN(Number(loanNumber))) return 0

  Api.setLoanNumber(loanNumber)
  return loanNumber
}

export function setBorrowerSeparator(borrowerSeparator: string) {
  Api.setBorrowerSeparator(borrowerSeparator)
}

export function getUtmParams() {
  const { href } = window.location
  const parsedUrl = new URL(href)
  const params = new URLSearchParams(parsedUrl.search)

  const data: Record<string, string> = {}
  params.forEach((value, key) => {
    if (!key.startsWith('utm_')) return
    data[key.replace('utm_', 'utm-')] = value
  })
  return data
}
